// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "wrapper-2KqvT";
var _5 = "wrapper_business-1J2CB";
var _6 = "header-164Ru";
var _7 = "header_withWeather-3sy5z";
var _8 = "cities-1-4YM";
var _9 = "plane__icon-2IRaF";
var _a = "city-NxltX";
var _b = "city__airport-Q6eEd";
var _c = "city__info-iyNhK";
var _d = "city__iata-3J5Qb";
var _e = "city__time-2Rga2";
var _f = "city__weather-mfG9f";
var _10 = "weather__icon-2IS6W";
var _11 = "flightInfo-S6nPt";
var _12 = "flightInfo__item-1baMz";
var _13 = "flightInfo__title-1PlrC";
var _14 = "flightInfo__value-2Ru8i";
var _15 = "footer-UDAKo";
var _16 = "footer__airline-z4jHa";
var _17 = "airline__logo-1SI3_";
var _18 = "airline__name-xEjOY";
var _19 = "footer__item-1055D";
var _1a = "footer__items-3GUgU";
var _1b = "footer__itemTitle-1AcDx";
var _1c = "footer__itemValue-3XxZs";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "wrapper", _5 as "wrapper_business", _6 as "header", _7 as "header_withWeather", _8 as "cities", _9 as "plane__icon", _a as "city", _b as "city__airport", _c as "city__info", _d as "city__iata", _e as "city__time", _f as "city__weather", _10 as "weather__icon", _11 as "flightInfo", _12 as "flightInfo__item", _13 as "flightInfo__title", _14 as "flightInfo__value", _15 as "footer", _16 as "footer__airline", _17 as "airline__logo", _18 as "airline__name", _19 as "footer__item", _1a as "footer__items", _1b as "footer__itemTitle", _1c as "footer__itemValue" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "wrapper": _4, "wrapper_business": _5, "header": _6, "header_withWeather": _7, "cities": _8, "plane__icon": _9, "city": _a, "city__airport": _b, "city__info": _c, "city__iata": _d, "city__time": _e, "city__weather": _f, "weather__icon": _10, "flightInfo": _11, "flightInfo__item": _12, "flightInfo__title": _13, "flightInfo__value": _14, "footer": _15, "footer__airline": _16, "airline__logo": _17, "airline__name": _18, "footer__item": _19, "footer__items": _1a, "footer__itemTitle": _1b, "footer__itemValue": _1c }
